export default "__VITE_ASSET__CWs08w3K__"